import { endpoints } from 'api/endpoints'
import { GetAllData, GetAllResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { BusinessType, BusinessTypeDataServer, BusinessTypesGetAllParams } from 'interfaces/api/templates.interfaces'
import { axios } from 'modules/axios'
import { defaultPagination, withoutPagination } from 'utils/pagination'

const getAll = async (params?: BusinessTypesGetAllParams): GetAllResponse<BusinessType> => {
  const { data: response } = await axios.request<GetAllData<BusinessType>>({
    method: 'GET',
    url: endpoints.templates.businessTypes.getAll(),
    params: {
      ...withoutPagination(params),
      ...defaultPagination(params),
    },
  })
  return response
}

const getSingle = async (id: number): GetOneResponse<BusinessType> => {
  const { data: response } = await axios.request<BusinessType>({
    method: 'GET',
    url: endpoints.templates.businessTypes.getSingle(id),
  })
  return response
}

const create = async (data: BusinessTypeDataServer): GetOneResponse<BusinessType> => {
  const { data: response } = await axios.request<BusinessType>({
    method: 'POST',
    url: endpoints.templates.businessTypes.create(),
    data,
  })
  return response
}

const update = async (id: number, data: BusinessTypeDataServer): GetOneResponse<BusinessType> => {
  const { data: response } = await axios.request<BusinessType>({
    method: 'PATCH',
    url: endpoints.templates.businessTypes.update(id),
    data,
  })
  return response
}

const remove = async (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.templates.businessTypes.remove(id),
  })

export const businessTypesApi = {
  getAll,
  getSingle,
  create,
  update,
  remove,
}
